import { vendorPreserve } from "@pages/ManualDocumentV2/forms/_shared/preserve";
import { ComplianceDocumentType } from "@utils/documentSeriesEnum";
import {
  branchByInvoiceType,
  defineForm,
  MANUAL_DOC_ENDPOINTS,
} from "../../../../core";
import { siiCreditNoteSchema } from "./schema";

export const siiCreditNoteConfig = defineForm({
  id: "sii_credit_note",
  createEndpoint: branchByInvoiceType(
    MANUAL_DOC_ENDPOINTS.SII_CREDIT_NOTE_ON_REGULAR,
    MANUAL_DOC_ENDPOINTS.SII_CREDIT_NOTE_ON_SIMPLIFIED_R5,
  ),
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "CreditNote",
  accountClass: "AccountReceivable",
  taxRatesChannel: "SII",
  invoiceType: "creditNote",
  complianceType: ComplianceDocumentType.CreditNote,
  requiresLegalRep: true,
  titleKey: "creditNote",
  complianceStandardKey: "sii",
  schema: siiCreditNoteSchema,
  preserveOnReset: vendorPreserve,
  sections: {
    customer: { hiddenFields: ["customerCompanyAddress"] },
  },
  omitFromPayload: ["customerCompanyAddress"],
});
